import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(idFichaVenta = '', idnurAutFichaVtaVeh = '0',cod_cia='0',cod_prov = '0',num_pedido_veh = '0',tipoFechaUno = '',tipoFechaDos = '') {

    // Tipos de compromiso  FCK,FCL,FRC,FRK,FRL

  const config ={
    params: {
      num_pedido_veh,
      //<I-89381>
      cod_cia,
      cod_prov,
      tipoFechaUno,
      tipoFechaDos,
      nurAutFichaVtaVeh:idnurAutFichaVtaVeh,
      //<F-89381>
    },
    headers:{
      idUsuario: IDUSUARIO,
      //<I-89381>
      /*cod_cia,
        cod_prov,
        tipoFechaUno,
        tipoFechaDos,
        nurAutFichaVtaVeh:idnurAutFichaVtaVeh,*/
      //<F-89381>      
    }
  }

  return customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${idFichaVenta}/listaFechaCompromiso`,config);
}



// WEBPACK FOOTER //
// ./src/utils/getFechasHistorial.js